<template>
  <div class="news">
    <div class="left">
      <img style="margin-bottom:12px" src="../../assets/img/news1.png" alt />
      <img src="../../assets/img/news2.png" alt />
    </div>
    <div class="right">
      <img src="../../assets/img/news3.png" alt />
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.news {
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  .right {
    img {
      width: 346px;
    }
  }
  .left {
    img {
      width: 540px;
    }
  }
}
</style>